module.exports = __webpack_public_path__ + "img/cy.293e9333.png";